import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PageLoaderService, PageLoaderState } from '../../services/page-loader.service';

@Component({
  selector: 'app-page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.css']
})
export class PageLoaderComponent implements OnInit, OnDestroy {
  progress = 0;

  state: PageLoaderState = {
    loading: false,
    error: false,
    message: 'Por favor espere...'
  };

  private interval: any;
  private sub!: Subscription;

  constructor(private pageLoaderService: PageLoaderService) {}

  ngOnInit(): void {
    this.sub = this.pageLoaderService.loading$.subscribe((state) => {
      this.state = state;

      if (state.loading) {
        this.startProgress();
      } else {
        this.stopProgress();
      }
    });
  }

  private startProgress(): void {
    this.progress = 0;

    if (this.interval) {
      clearInterval(this.interval);
    }

    this.interval = setInterval(() => {
      if (this.progress < 95) {
        this.progress += 2;
      }
    }, 80);
  }

  private stopProgress(): void {
    this.progress = 100;

    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  retry(): void {
    window.location.reload();
  }

  close(): void {
    this.pageLoaderService.forceHide();
  }

  ngOnDestroy(): void {
    this.stopProgress();

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}